import Head from 'next/head'
import Footer from './footer/footer'
import Header from './header/header'
import styles from './layout.module.scss';

const Layout = ({ children, header, setHide, footer, mainDir, audio, audio2 }) => {

  //console.log(audio2);
  return (
    <div className="body">
      <Head>
        <title>{`'במסתרים׳ ילדי מסתור בתקופת השואה. תערוכה וירטואלית.`}</title>
        <meta name="description" content="גנזך קידוש השם מציגים: חוויה אינטראקטיבית על ילדי מסתור בתקופת השואה. למדו על פרידתם מההורים, המסתור, ההצלה והשיקום לאחר המלחמה. מותאם לבני נוער. התחילו בסיור." />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      
      {header == 'hide' ? '' : (
        <Header 
          setHide={setHide}
          music={audio} 
          music2={audio2}
        />
      )}
      
      <main 
      id='main'
      className={`main relative z-30 max-w-full overflow-hidden ${mainDir == 'ltr' ? styles.dirLtr : styles.dirRtl}`} >
        { children }
      </main>

      {footer == 'hide' ? '' : (
        <Footer />
      )}
      
    </div>
  )
}

export default Layout;